// extracted by mini-css-extract-plugin
export default {"login":"login_login__FE5d9"};